import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_k5zKjjlWr',
      userPoolClientId: '1alvncmurso85aevbf54calea3',
      loginWith: {
        email: true,
        username: false
      }
    }
  }
});



